/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.27",
    versionName: "0.2.0-nightly.2025.10.27",
    versionChannel: "nightly",
    buildDate: "2025-10-27T00:09:35.729Z",
    commitHash: "edc63feb417250b22174a3d03620b70899f1c548",
};
